module.exports = __webpack_public_path__ + "img/4@s.7e5d9f54.jpg";